import { URLs } from '.'
import * as pages from '../pages'

export const paymentUrls: URLs = {
  payment: {
    urls: {
      default: '/payment',
      nl: '/betaling',
      be: '/betaling',
      de: '/zahlung',
      dk: '/betaling',
    },
    component: pages.Payment,
    funnel: true,
  },
  custompayment: {
    urls: {
      default: '/payment/:slug',
      nl: '/betaling/:slug',
      be: '/betaling/:slug',
      de: '/zahlung/:slug',
      dk: '/betaling/:slug',
    },
    component: pages.Payment,
  },
  molliepayment: {
    urls: {
      default: '/mollie/payment',
      nl: '/mollie/betaling',
      be: '/mollie/betaling',
      de: '/mollie/zahlung',
      dk: '/mollie/betaling',
    },
    component: pages.MolliePayment,
    funnel: true,
  },
  molliecustompayment: {
    urls: {
      default: '/mollie/payment/:slug',
      nl: '/mollie/betaling/:slug',
      be: '/mollie/betaling/:slug',
      de: '/mollie/zahlung/:slug',
      dk: '/mollie/betaling/:slug',
    },
    component: pages.MolliePayment,
  },
  mollieBookingComplete: {
    urls: {
      default: '/mollie/booking/complete',
      dk: '/mollie/booking/bekraeftelse',
    },
    component: pages.MollieBookingComplete,
  },
  mollieGiftcardComplete: {
    urls: {
      default: '/mollie/giftcard/complete',
      dk: '/mollie/gavekort/bekraeftelse',
    },
    component: pages.MollieGiftcardComplete,
  },
  confirmed: {
    urls: {
      default: '/booked',
      nl: '/geboekt',
      be: '/geboekt',
      uk: '/booked',
      ie: '/booked',
      dk: '/bestilt',
    },
    component: pages.Confirmed,
  },
  customPaymentThanks: {
    urls: {
      default: '/payment-successful',
      nl: '/betaling-gelukt',
      be: '/betaling-gelukt',
      dk: '/betaling-vellykket',
    },
    component: pages.CustomPaymentThanks,
  },
  giftcardThanks: {
    urls: {
      default: '/giftcard-successful',
      dk: '/gavekort-vellykket',
    },
    component: pages.CustomPaymentThanks,
  },
  topupThanks: {
    urls: {
      default: '/activeren-successful',
    },
    component: pages.CustomPaymentThanks,
  },
}

export const pageNames = Object.values(paymentUrls)
